import { useState, useEffect } from 'react';
import { listProfiles, createProfile, updateProfile, deleteProfile } from '@services/userService';
import Table from '@components/ui/Table';
import Button from '@components/ui/Button';
import Modal from '@components/ui/Modal';
import ProfileForm from './ProfileForm';
import { PlusCircle, Edit, Trash2 } from 'lucide-react';

export default function ProfileList() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  const fetchProfiles = async () => {
    try {
      setLoading(true);
      const data = await listProfiles();
      setProfiles(data);
    } catch (error) {
      console.error('Erro ao buscar perfis:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfiles();
  }, []);

  const handleOpenModal = (profile = null) => {
    setSelectedProfile(profile);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedProfile(null);
    setIsModalOpen(false);
  };

  const handleSaveProfile = async (profileData) => {
    try {
      if (selectedProfile) {
        await updateProfile(selectedProfile.id, profileData);
      } else {
        await createProfile(profileData);
      }
      fetchProfiles();
      handleCloseModal();
    } catch (error) {
      console.error('Erro ao salvar perfil:', error);
    }
  };

  const handleDeleteProfile = async (profileId) => {
    if (window.confirm('Tem certeza que deseja excluir este perfil?')) {
      try {
        await deleteProfile(profileId);
        fetchProfiles();
      } catch (error) {
        console.error('Erro ao excluir perfil:', error);
      }
    }
  };

  const columns = [
    { label: 'Nome', key: 'name' },
    { label: 'Descrição', key: 'description' },
    {
      label: 'Ações',
      key: 'id',
      sortable: false,
      render: (value) => (
        <div className="flex space-x-2">
          <Button variant="icon" onClick={() => handleOpenModal(profiles.find(p => p.id === value))}>
            <Edit className="h-4 w-4" />
          </Button>
          <Button variant="icon" onClick={() => handleDeleteProfile(value)}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Perfis</h2>
        <Button variant="primary" onClick={() => handleOpenModal()}>
          <PlusCircle className="h-4 w-4 mr-2" />
          Novo Perfil
        </Button>
      </div>
      <Table columns={columns} data={profiles} isLoading={loading} />
      {isModalOpen && (
        <Modal isOpen={isModalOpen} title={selectedProfile ? 'Editar Perfil' : 'Novo Perfil'} onClose={handleCloseModal}>
          <ProfileForm profile={selectedProfile} onSave={handleSaveProfile} onCancel={handleCloseModal} />
        </Modal>
      )}
    </div>
  );
}